import { useEffect, useState } from "react";
import { Button, Typography, Spin } from "antd";
import { useStrategy } from "./useCreateStrategyContext";
import styles from "../../../styles/Components/new-insight/create-strategy/CreateStrategyForm.module.css";
import { useDispatch, useSelector } from "react-redux";
import { editStrategy } from "../../../redux/new-insight/actions";
import { useShowCreateStrategyContext } from "./CreateStrategyModal";
import StrategyName from "./strategy-form/StrategyName";
import StrategyLabel from "./strategy-form/StrategyLabel";
import StrategyTag from "./strategy-form/StrategyTag";
import StrategyDescription from "./strategy-form/StrategyDescription";
import { FaCircleCheck } from "react-icons/fa6";
import useUserData from "../../../hooks/useUserData";

function CreateStrategyForm({ data, goToPrevStep }) {
  const {
    main: { userData },
    newInsightState: {
      createStrategyStatus,
      editStrategyStatus,
      createStrategyResult,
    },
  } = useSelector((state) => state);

  const {
    strategy_name: name,
    strategy_description: description,
    strategy_tag: tag,
    strategy_label: label,
  } = createStrategyResult;

  const dispatch = useDispatch();
  const [isCustomTag, setIsCustomTag] = useState(false);
  const {
    setStrategyInfo,
    state: {
      strategyList,
      strategyId = "",
      strategyName,
      strategyTag,
      strategyLabel,
      strategyDescription,
      mode,
      strategyInfo,
    },
    resetData,
    setMode,
  } = useStrategy();

  const { username, email } = useUserData();

  const isLoading =
    editStrategyStatus === "loading" || createStrategyStatus === "loading";

  const closeModal = useShowCreateStrategyContext();

  const goBackHandler = () => {
    goToPrevStep();
    setMode("edit-create");
  };

  const isModified =
    strategyName !== name ||
    strategyDescription !== description ||
    strategyTag.length !== tag?.length ||
    strategyLabel?.length !== label?.length;

  const modifyHandler = async () => {
    if (isLoading || !isModified) return;

    let changedFields = [];
    let changedValues = [];

    if (strategyName !== name) {
      changedFields.push("strategy_name");
      changedValues.push(strategyName);
    }
    if (strategyDescription !== description) {
      changedFields.push("strategy_description");
      changedValues.push(strategyDescription);
    }
    if (strategyTag.length !== tag.length) {
      changedFields.push("strategy_tag");
      changedValues.push(strategyTag);
    }
    if (strategyLabel.length !== label.length) {
      changedFields.push("strategy_label");
      changedValues.push(strategyLabel);
    }

    await dispatch(
      editStrategy(
        username,
        email,
        createStrategyResult?.createdDate,
        changedFields,
        changedValues,
      ),
    );
    closeModal(); // Close the modal after the dispatch completes
  };

  useEffect(() => {
    const { strategy_name, strategy_description } = createStrategyResult;
    if (createStrategyStatus === "idle") {
      setStrategyInfo({
        strategy_name,
        strategy_description,
        strategy_tag: [],
        strategy_label: [],
      });
    }
  }, [createStrategyStatus, createStrategyResult]);

  return (
    <div className={styles.container}>
      {isLoading && (
        <div className={styles.loader}>
          <Spin />
          <h4>
            {mode?.includes("edit") || editStrategyStatus === "loading"
              ? "Updating"
              : "Creating"}{" "}
            your strategy...
          </h4>
        </div>
      )}
      {/* Title */}
      {!isLoading && createStrategyStatus === "idle" && (
        <>
          <div className={styles.successBadge}>
            <FaCircleCheck />
            Strategy pack {mode?.includes("edit") ? "updated" : "created"}{" "}
            successfully.
          </div>
          <Typography.Title level={5} style={{ fontFamily: "inherit" }}>
            Strategy Details:
          </Typography.Title>
          <StrategyName />
          <StrategyDescription />
          <StrategyLabel />
          <StrategyTag />
          <div className={styles.handlers}>
            <div
              className={`${styles.btn} ${styles.backBtn}`}
              onClick={goBackHandler}
            >
              Back
            </div>
            <Button
              className={`${styles.btn} ${styles.modifyBtn}`}
              disabled={!isModified}
              onClick={modifyHandler}
            >
              Modify
            </Button>
          </div>
        </>
      )}

      {createStrategyStatus === "error" && (
        <h4 className={styles.errorBox}>
          Something went wrong! Try again later.
        </h4>
      )}
    </div>
  );
}

export default CreateStrategyForm;

// const onFinish = async (values) => {
//   const { strategy_name, strategy_label, strategy_tag } = values;
//   const info = {
//     strategy_name,
//     strategy_label: strategy_label || "",
//     strategy_tag: strategy_tag || "",
//   };
//   setStrategyInfo(info);
//
//   if (mode !== "edit") {
//     await dispatch(
//       createStrategyPack(
//         userData["custom:custom_username"],
//         userData?.email,
//         "crypto",
//         strategy_name,
//         strategy_label,
//         strategy_tag,
//         strategyList,
//       ),
//     ).then(() => {
//       resetData();
//       closeModal();
//     });
//   } else {
//     const allFields = Object.keys(values);
//     let changedFields = ["list_feature_info"];
//     const featuresString = JSON.stringify(strategyList);
//     let changedValues = [featuresString];
//
//     allFields.forEach((f) => {
//       if (values[f] !== data?.strategyInfo[f]) {
//         changedFields.push(f);
//         changedValues.push(values[f]);
//       }
//     });
//
//     if (changedFields.length === 0) {
//       closeModal();
//       return;
//     }
//
//     // Dispatch the edit strategy action and wait for completion
//     try {
//       await dispatch(
//         editStrategy(
//           userData["custom:custom_username"],
//           userData?.email,
//           strategyId,
//           changedFields,
//           changedValues,
//         ),
//       );
//       closeModal(); // Close the modal after the dispatch completes
//     } catch (error) {
//       console.error("ErrorComponent updating strategy:", error);
//     }
//   }
// };
